module.exports = __webpack_public_path__ + "img/wild2.cae502be.png";